<form
  *ngIf="form && form.controls && formFieldConfig.length > 0"
  class="form-horizontal"
  [formGroup]="form"
  (submit)="handleSubmit($event)"
>
  <div class="card card-accent-primary shadowed">
    <div class="card-header card-filter-header">
      <i class="fa fa-search"></i>
      <strong>{{genericVisuals.filter}}</strong>
      <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
    </div>

    <div class="card-block" [collapse]="isCollapsed">
      <div class="form-group row justify-content-end form-top-required-fields-container">
        <div class="col-md-9 text-left small text-muted">
          <!--                    {{genericVisuals.formRequiredFields}}-->
        </div>
      </div>
      <div class="row">
        @for (field of formFieldConfig; track $index) {
          <div
            [ngClass]="field.containerClass && field.containerClass!=''? field.containerClass : 'col-sm-12'"
          >
            <div *ngIf="field.type == 'input'" class="form-group row" [formGroup]="form">
              <label
                class="form-control-label mb-0 align-self-center {{getClassReq(field.validation)}}"
                for="{{field.name}}"
                [ngClass]="field.labelClass && field.labelClass!=''? field.labelClass : 'col-md-3 text-md-right'"
                >{{visuals[field.label]}}</label
              >
              <div
                [ngClass]="field.inputClass && field.inputClass!=''? field.inputClass : 'col-md-9'"
              >
                <input
                  id="{{field.name}}"
                  class="form-control"
                  type="text"
                  [attr.placeholder]="field.placeholder"
                  [formControlName]="field.name"
                />
              </div>
              <div
                *ngIf="formErrors && formErrors[field.name] != ''"
                [ngClass]="field.errorMsgClass && field.errorMsgClass!=''? field.errorMsgClass : 'offset-md-3 col-md-9 col-sm-12'"
              >
                <p class="text-danger font-sm mb-0" role="alert">
                  {{formErrors[field.name]}}
                </p>
              </div>
            </div>

            <div *ngIf="field.type == 'modal'" class="form-group row" [formGroup]="form">
              <label
                class="form-control-label mb-0 align-self-center {{getClassReq(field.validation)}}"
                for="{{field.name}}"
                [ngClass]="field.labelClass && field.labelClass!=''? field.labelClass : 'col-md-3 text-md-right'"
                >{{visuals[field.label]}}</label
              >
              <div
                class="input-group"
                [ngClass]="field.inputClass && field.inputClass!=''? field.inputClass : 'col-md-9'"
              >
                <input
                  id="{{field.name}}"
                  class="form-control dynamic-modal-input"
                  type="text"
                  [attr.placeholder]="field.placeholder"
                  [formControlName]="field.name"
                />
                <basesearchmodal
                  [type]="field.modaltype"
                  (valueChange)="valueChanged(field.modaltype,$event)"
                ></basesearchmodal>
              </div>

              <div
                *ngIf="formErrors && formErrors[field.name] != ''"
                [ngClass]="field.errorMsgClass && field.errorMsgClass!=''? field.errorMsgClass : 'offset-md-3 col-md-9 col-sm-12'"
              >
                <p class="text-danger font-sm mb-0" role="alert">
                  {{ formErrors[field.name] }}
                </p>
              </div>
            </div>

            <div *ngIf="field.type == 'date'" class="form-group row" [formGroup]="form">
              <label
                class="form-control-label mb-0 align-self-center {{getClassReq(field.validation)}}"
                for="{{field.name}}"
                [ngClass]="field.labelClass && field.labelClass!=''? field.labelClass : 'col-md-3 text-md-right'"
                >{{visuals[field.label]}}</label
              >

              <div
                [ngClass]="field.inputClass && field.inputClass!=''? field.inputClass : 'col-md-9'"
              >
                <input
                  id="{{field.name}}"
                  [formControlName]="field.name"
                  class="form-control form-control-date"
                  date-format="DD/MM/YYYY"
                  ng2-datetime-picker
                  date-only="true"
                />
              </div>

              <div
                *ngIf="formErrors && formErrors[field.name] != ''"
                [ngClass]="field.errorMsgClass && field.errorMsgClass!=''? field.errorMsgClass : 'offset-md-3 col-md-9 col-sm-12'"
              >
                <p class="text-danger font-sm mb-0" role="alert">
                  {{formErrors[field.name]}}
                </p>
              </div>
            </div>

            <div *ngIf="field.type == 'select'" class="form-group row" [formGroup]="form">
              <label
                class="form-control-label mb-0 align-self-center {{getClassReq(field.validation)}}"
                for="{{field.name}}"
                [ngClass]="field.labelClass && field.labelClass!=''? field.labelClass : 'col-md-3 text-md-right'"
                >{{visuals[field.label]}}</label
              >
              <div
                [ngClass]="field.inputClass && field.inputClass!=''? field.inputClass : 'col-md-9'"
              >
                <ng-select
                  #ngSelect
                  [formControlName]="field.name"
                  [items]="field.lookup"
                  (data)="setValueSelected(field.name,$event)"
                  bindValue="id"
                  bindLabel="text"
                ></ng-select>
              </div>
            </div>

            <div *ngIf="field.type == 'currency'" class="form-group row" [formGroup]="form">
              <label
                class="form-control-label mb-0 align-self-center {{getClassReq(field.validation)}}"
                for="{{field.name}}"
                [ngClass]="field.labelClass && field.labelClass!=''? field.labelClass : 'col-md-3 text-md-right'"
                >{{visuals[field.label]}}</label
              >
              <div
                class="input-group"
                [ngClass]="field.inputClass && field.inputClass!=''? field.inputClass : 'col-md-9'"
              >
                <input
                  id="{{field.name}}"
                  currencyMask
                  class="form-control"
                  [formControlName]="field.name"
                  type="tel"
                />
              </div>
              <div
                *ngIf="formErrors && formErrors[field.name] != ''"
                [ngClass]="field.errorMsgClass && field.errorMsgClass!=''? field.errorMsgClass : 'offset-md-3 col-md-9 col-sm-12'"
              >
                <p class="text-danger font-sm mb-0" role="alert">
                  {{formErrors[field.name]}}
                </p>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="form-group row justify-content-end form-bottom-required-fields-container">
        <div class="col-md-12 text-left small text-muted"></div>
      </div>
    </div>
    <div
      class="card-footer card-filter-footer"
      style="text-align: center;"
      [collapse]="isCollapsed"
    >
      <button class="btn btn-outline-default btn-filter-clear" type="reset" [disabled]="loading">
        <i class="fa fa-close"></i>
        {{genericVisuals.clear}}
      </button>
      <button
        class="btn btn-primary btn-shadowed btn-filter-search"
        type="submit"
        [disabled]="!form.valid || loading"
      >
        <i class="fa fa-search"></i>
        {{genericVisuals[formType]}}
      </button>
    </div>
  </div>
</form>
